import fetch from 'isomorphic-fetch'
import Parse from 'url-parse'

import {
  INIT_ASSIGNMENT_REQUEST,
  INIT_ASSIGNMENT_SUCCESS,
  INIT_ASSIGNMENT_FAILURE
} from '../actions'

import { userAssignmentPayload, getAPIendpointPrefix } from './apiHelper.js'
import { getCookie } from '../middleware/macmillan'

// Send assignment and activity details to API for reporting purposes.
// Otherwise, the LC backend has no way of associating an assignment_id with an LC activity.
export default (activity) => {
  return (dispatch) => {
    let payload
    try {
      payload = userAssignmentPayload(activity)
    } catch (e) {
      return Promise.reject('cannot post assignment--missing required data')
    }
    const curUrl = new Parse(window.location.href, null, true)
    if (curUrl.query.course_id !== undefined) {
      payload.course_id = curUrl.query.course_id
    }
    if (curUrl.query.settingsTemplateId !== undefined) {
      payload.settings_template_id = curUrl.query.settingsTemplateId
    }

    payload.activity_file = activity.config.file ? activity.config.file : 'fixtures'
    payload.activity_title = activity.activityTitle

    // also send requirements to verify token
    payload.token = getCookie('id_token')
    payload.resourceId = activity.config.itemId

    const payloadString = JSON.stringify(payload)

    dispatch({ type: INIT_ASSIGNMENT_REQUEST })

    return fetch(getAPIendpointPrefix() + 'api/v1/assignment.php',
      {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        },
        body: payloadString
      })
      .then(response => {
        const contentType = response.headers.get('content-type')
        if (contentType && contentType.includes('application/json')) {
          return response.json()
        } else {
          return Promise.resolve({ error: 'unknown error' })
        }
      })
      .then(json => {
        return json.error
          ? dispatch({ type: INIT_ASSIGNMENT_FAILURE, payload: json })
          : dispatch({ type: INIT_ASSIGNMENT_SUCCESS, payload: json })
      })
  }
}
